module.exports = __webpack_public_path__ + "static/img/img3.607f2e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landingPage/bussiness/img3.png
// module id = 9itW
// module chunks = 30